import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconBrandHire(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="url(#a)"
        d="M0 16.166a9.649 9.649 0 0 1 5.146 2.688A9.648 9.648 0 0 1 7.834 24h3.27a12.868 12.868 0 0 0-3.673-7.43A12.868 12.868 0 0 0 0 12.896v3.269Z"
      />
      <path
        fill="url(#b)"
        d="M5.146 5.146A9.649 9.649 0 0 0 7.834 0h3.27A12.868 12.868 0 0 1 7.43 7.43 12.868 12.868 0 0 1 0 11.104V7.834a9.648 9.648 0 0 0 5.145-2.688Z"
      />
      <path
        fill="url(#c)"
        d="M24 12.897a12.868 12.868 0 0 0-7.43 3.672A12.867 12.867 0 0 0 12.897 24h3.269a9.648 9.648 0 0 1 2.688-5.146A9.648 9.648 0 0 1 24 16.166v-3.27Z"
      />
      <path
        fill="url(#d)"
        d="M24 7.834a9.649 9.649 0 0 1-5.146-2.688A9.648 9.648 0 0 1 16.166 0h-3.27a12.868 12.868 0 0 0 3.673 7.43A12.868 12.868 0 0 0 24 11.104V7.834Z"
      />
      <defs>
        <linearGradient id="a" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="b" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="c" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="d" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
